import { CachedDataService } from './auth/_core/cached-data.service';
import 'rxjs/add/operator/mergeMap';
import { filter } from 'rxjs/operators';

import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './_services/authentication.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root, [app-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = '';
  titleComp = ' - Área do Veterinário';
  isLoggedIn = false;

  constructor(
    private _authService: AuthenticationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _titleService: Title,
    private _cachedService: CachedDataService
  ) {
    this._authService.isLoggedIn.subscribe(
      (data) => {
        this.isLoggedIn = data;
      }
    );
  }

  ngOnInit() {
    this._router.events
      .filter((event) => event instanceof NavigationEnd)
      .map(() => this._activatedRoute)
      .map((route) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      })
      .filter((route) => route.outlet === 'primary')
      .mergeMap((route) => route.data)
      .subscribe((event) => {
        this.setTitle(event['title']);
      });
  }

  setTitle(newTitle: string): void {
    this.title = newTitle;
    this._titleService.setTitle(this.title + this.titleComp);
  }

}
